module.exports = __webpack_public_path__ + "img/sdg-front-end.netlify.app_.png.9ade1ab7.webp";